import LightboxPrompt from "../../../../components/lightbox-prompt/lightbox-prompt";
import { useTranslation } from "react-i18next";
import styles from "./cancel-prompt.module.scss";
import React from "react";
import MyNexarButton from "../../../../../../components/button/button";

interface propsType {
  onCancelAll(): void;
  onCancelOne(): void;
  cancelOneHref: string;
  onClose?(): void;
}
export default function CancelPrompt(props: propsType) {
  const { t } = useTranslation();
  return (
    <LightboxPrompt
      title={t("beforeYouContinue")}
      frameClassName={styles.Frame}
      onBackdropClick={props.onClose}
    >
      <p>{t("doYouWantToCancel")}</p>
      <MyNexarButton link={props.cancelOneHref} action={props.onCancelOne}>
        {t("cancelOneSubscription")}
      </MyNexarButton>
      <MyNexarButton
        alt={true}
        hideOutline={true}
        action={() => props.onCancelAll()}
      >
        {t("cancelAllSubscriptions")}
      </MyNexarButton>
    </LightboxPrompt>
  );
}
